import React, { useEffect, useState } from "react";
import { endpoints } from "../../constants/Endpoints";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  department as recoilDepart,
  exam as recoilExam,
  selectedDepartmentObject,
  selectedLanguage,
} from "../../providers/index";
import { instance } from "../../services/https/inceptors";
import EmptyIcon from "../../components/EmptyIcon/index";
import { LANGUAGES, MODULES } from "../../constants/Common";
import Actions from "../../components/Action/index";
import { useHistory } from "react-router-dom";
import ReactSelect from 'react-select';

const GeneralVideo = () => {
  const [generalVideo, setGeneralVideo] = useState();
  const department = useRecoilValue(recoilDepart).split("/")[1];
  const exam = useRecoilValue(recoilExam).split("/")[1];
  const { push } = useHistory();
  const selectedDepart = useRecoilValue(selectedDepartmentObject);
  const [currentLanguage, setCurrentLanguage] = useRecoilState(selectedLanguage);

  const getAllVideos = async () => {
    const res = await instance.get(
      `${endpoints.getAllVideos}?exam=${exam}&department=${department}`
    );
    setGeneralVideo(res.data);
  };

  useEffect(() => {
    getAllVideos();
  }, []);

  return (
    <div className="container">
      <div className="flex flex-col justify-center items-center my-4">
        <div
          className="d-flex justify-content-center rounded w-25 p-2 btn-hover c-pointer"
          onClick={() => push("/create-video")}
        >
          Create General Video
        </div>

        <div className='mt-4'>
          <h6 className='mb-1 text-center'>Select Language</h6>
          <ReactSelect
            onChange={setCurrentLanguage}
            options={selectedDepart?.languages?.map((lang) => {
              const label = Object.keys(LANGUAGES).find(
                (key) => LANGUAGES[key] === lang
              );
              return {
                value: lang,
                label: label.replace(/^./, label[0].toUpperCase()),
              };
            })}
            value={currentLanguage}
            placeholder='Select Language'
            className='w-52'
          />
        </div>
      </div>

      <div className="mt-5 m-auto w-50">
        {generalVideo?.length ? (
          <Actions
            language={currentLanguage}
            primary={true}
            type={MODULES.GENERAL_VIDEO}
            data={generalVideo}
            setData={setGeneralVideo}
          />
        ) :
          <EmptyIcon />
        }
      </div>
    </div>
  );
};

export default GeneralVideo;
